import React, { useState } from "react";
import { errorMessage } from "../../services";
import { exportCatalog, importCatalog } from "../../services/products";
import { Spinner } from "../../components/Loader";

// Website editor -> Products: download the catalogue as Excel / CSV, or upload one to add and update products.
// Import changes the saved catalogue directly, so unsaved edits must be saved first (the editor reloads after).
export default function CatalogTransfer({ siteId, notify, saved, onImported }) {
  const [busy, setBusy] = useState("");
  const [result, setResult] = useState(null);

  const download = async (format) => {
    setBusy(format);
    try {
      await exportCatalog(siteId, format);
    } catch (err) {
      notify(errorMessage(err), "error");
    } finally {
      setBusy("");
    }
  };

  const upload = async (e) => {
    const file = e.target.files && e.target.files[0];
    e.target.value = "";
    if (!file) return;
    setBusy("import");
    setResult(null);
    try {
      const { data } = await importCatalog(siteId, file);
      setResult(data);
      notify(data.message, data.errors.length ? "warn" : "ok");
      onImported();
    } catch (err) {
      notify(errorMessage(err), "error");
    } finally {
      setBusy("");
    }
  };

  return (
    <div className="catalog-transfer">
      <div className="catalog-transfer-head">
        <div>
          <b>Import / export products</b>
          <small>Excel or CSV. Export first to get a ready template with your products and categories.</small>
        </div>
        <div className="catalog-transfer-actions">
          <button type="button" className="outline-btn" onClick={() => download("xlsx")} disabled={Boolean(busy)}>{busy === "xlsx" ? <Spinner /> : "⇩"} Excel</button>
          <button type="button" className="outline-btn" onClick={() => download("csv")} disabled={Boolean(busy)}>{busy === "csv" ? <Spinner /> : "⇩"} CSV</button>
          <label className={`primary-btn catalog-import ${!saved || busy ? "is-disabled" : ""}`} title={saved ? "" : "Save your changes first"}>
            {busy === "import" ? <><Spinner /> Importing</> : "⇧ Import file"}
            <input type="file" accept=".xlsx,.csv" onChange={upload} disabled={!saved || Boolean(busy)} />
          </label>
        </div>
      </div>
      {!saved && <p className="catalog-transfer-note">Save your changes before importing.</p>}
      {result && (
        <div className={`catalog-result ${result.errors.length ? "has-errors" : ""}`}>
          <div className="catalog-result-counts">
            <span><b>{result.created}</b> added</span>
            <span><b>{result.updated}</b> updated</span>
            <span><b>{result.categoriesCreated}</b> new categories</span>
            {result.errors.length > 0 && <span className="bad"><b>{result.errors.length}</b> skipped</span>}
          </div>
          {result.errors.length > 0 && (
            <ul>
              {result.errors.slice(0, 20).map((err) => <li key={err.row}>Row {err.row}: {err.message}</li>)}
              {result.errors.length > 20 && <li>…and {result.errors.length - 20} more</li>}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}
